import { LaravelResponse, keyToUrl, withOptionsEndpoint } from "@dgs/core";
import axios from "axios";
import { CountryOptionResource } from "../types/country";

const baseKey = "countries";
const defaultCountryKey = [baseKey, "default"];

export const countryService = {
	...withOptionsEndpoint<CountryOptionResource>([baseKey]),
	getDefaultCountry: () => axios.get<LaravelResponse<CountryOptionResource | null>>(keyToUrl(defaultCountryKey)),
	defaultCountryKey,
};
